import React from 'react';

const BrandGallery = () => {
    return (
        <div className="brand-gallery-wrapper">
            <div className="row">
                <div className="col-lg-3">
                    <div className="brand-logo d-flex justify-content-between justify-content-lg-center align-items-center flex-row-reverse flex-lg-column">
                        <img src="./assets/sample-image/R.png" alt="logo"/>
                        <p className="text xmt-3">صفحه رسمی برند بیسوس</p>
                    </div>
                </div>
                <div className="col-lg-9">
                    <div className="row">
                        <div className="col-6 col-lg-6 xmt-4 xpx-2 xpx-lg-3">
                            <div className="store-products"
                                 style={{backgroundImage: "url('./assets/sample-image/Huawei.png')"}}>
                                <span className="text">انواع کابل گوشی</span>
                            </div>
                        </div>
                        <div className="col-6 col-lg-6 xmt-4 xpx-2 xpx-lg-3">
                            <div className="store-products"
                                 style={{backgroundImage: "url('./assets/sample-image/g.png')"}}>
                                <span className="text">انواع هدفون</span>
                            </div>
                        </div>
                        <div className="col-6 col-lg-4 xmt-4 xpx-2 xpx-lg-3 xmt-lg-5">
                            <div className="store-products"
                                 style={{backgroundImage: "url('./assets/sample-image/MaskGroup1.png')"}}>
                                <span className="text">انواع شارژر موبایل</span>
                            </div>
                        </div>
                        <div className="col-6 col-lg-4 xmt-4 xpx-2 xpx-lg-3 xmt-lg-5">
                            <div className="store-products"
                                 style={{backgroundImage: "url('./assets/sample-image/huawei-matebook-13-banner-pc_v2e.png')"}}>
                                <span className="text">انواع پاوربانک</span>
                            </div>
                        </div>
                        <div className="col-lg-4 xmt-4 xpx-2 xpx-lg-3 xmt-lg-5">
                            <div className="store-products"
                                 style={{backgroundImage: "url('./assets/sample-image/ezgif.com-gif-maker.png')"}}>
                                <span className="text">انواع لوازم جانبی خودرو</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BrandGallery;
